import React from 'react'
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import AudioVisualiser from './AudioVisualiser';

interface Props {
  enabledAudio: boolean;
}

interface State {
  audio: MediaStream | null;
  audioData: Uint8Array | any
}

declare global {
  interface Window {
    webkitAudioContext: typeof AudioContext
  }
}

class AudioView extends React.Component<Props, State> {

  private audioContext: AudioContext | null;
  private analyser: AnalyserNode | null;
  private dataArray: Uint8Array;
  private sourceNode: MediaStreamAudioSourceNode | null;
  private bufferLength: number
  private rafId: number

  constructor(props: Props) {
    super(props);
    this.state = { 
      audio: null,
      audioData: new Uint8Array(0) 
    };
    this.tick = this.tick.bind(this);
    this.audioContext = null;
    this.analyser = null;
    this.dataArray = new Uint8Array();
    this.sourceNode = null;
    this.bufferLength = 0;
    this.rafId = 0;
    
  }

  async componentDidMount() {
    const { enabledAudio } = this.props
    let audioInfo = null
    if(enabledAudio) {
      audioInfo = await this.getMicrophone()
    }
    this.initAnimationFrame(audioInfo) 

  }

  async getMicrophone() {
    const audio = await navigator.mediaDevices.getUserMedia({
      audio: true,
      video: false
    });
    this.setState({ audio });
  }

  stopMicrophone() {
    if(this.state.audio !== null) {
      this.state.audio.getTracks().forEach(track => track.stop());
    }
    this.setState({ audio: null });
  }

  initAnimationFrame(audioInfo: any) {
    if(audioInfo !== null && this.state.audio !== null) {
      this.audioContext = new (window.AudioContext ||
        window.webkitAudioContext)();
      this.analyser = this.audioContext.createAnalyser();
      this.analyser.smoothingTimeConstant = 0.85;
      this.analyser.fftSize = 1024;
      this.bufferLength = this.analyser.frequencyBinCount
      this.dataArray = new Uint8Array(this.bufferLength);
      this.sourceNode = this.audioContext.createMediaStreamSource(this.state.audio);
      this.sourceNode.connect(this.analyser);
      this.rafId = requestAnimationFrame(this.tick);
    }
  }  

  toggleMicrophone() {
    if (this.state.audio) {
      this.stopMicrophone();
    } else {
      this.getMicrophone();
    }
  }



  tick() {
    if (this.dataArray) {
      this.analyser !== null && this.analyser.getByteTimeDomainData(this.dataArray)
      this.setState({ audioData: this.dataArray });
    }
    this.rafId = requestAnimationFrame(this.tick);
  }

  componentWillUnmount() {
    cancelAnimationFrame(this.rafId);
    this.analyser !== null && this.analyser.disconnect();
    this.sourceNode !== null && this.sourceNode.disconnect();
    this.setState({ audio: null });
  }

  async componentDidUpdate(prevProps: Props) {
    if (prevProps.enabledAudio !== this.props.enabledAudio) {
      if (this.props.enabledAudio) {
        const audioInfo = await this.getMicrophone()
        this.initAnimationFrame(audioInfo) 
      } else {
        this.stopMicrophone();
      }
    }
  }  

  render() {
    return (
      <Box position="relative" margin="25px 0px 20px">
        <AudioVisualiser rotate={'90'} left={'auto'} right={'80'} audioData={this.state.audioData} />
        <Typography variant="subtitle1" display="inline" align="center" gutterBottom>
          Audio Test
        </Typography>
        <AudioVisualiser rotate={'-90'} left={'80'} right={'auto'} audioData={this.state.audioData} />
      </Box>
    );
  }
}

export default AudioView;
